import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../../data/landing';
import { CtaButton } from '../CtaButton';
import { SectionHeading } from '../SectionHeading';
export function Bonuses() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-115" data-mp="1clzc0idd4o2w">
      <div className="mx-auto max-w-5xl px-5" data-id="element-116" data-mp="18jul3reau5jy">
        <div className="flex justify-center" data-id="element-117" data-mp="18l5ovr7qvdb2">
          <span className="inline-flex items-center gap-2 rounded-full bg-alert px-4 py-1.5 text-sm font-extrabold uppercase tracking-wider text-white" data-id="element-118" data-mp="259v9vqeo4m19">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-119" data-mp="20ba6ji44dm8l" /> Today only
          </span>
        </div>
        <div className="mt-5" data-id="element-120" data-mp="1w7lxeuzuail8">
          <SectionHeading title={<>
                5 exclusive bonuses — <span className="italic text-cta" data-id="element-122" data-mp="1rceys1lfg436">included free</span>
              </>} sub={<>
                Total bonus value: <strong className="text-navy line-through decoration-alert decoration-2" data-id="element-123" data-mp="ftvuhrkgi0d6">$147 USD</strong>
              </>} data-id="element-121" data-mp="1ra2jxxayu9uc" />
        </div>
      </div>

      <ol className="mx-auto mt-12 max-w-5xl space-y-14 md:px-5" data-id="element-124" data-mp="1jshvzfndxa9j">
        {bonuses.map(b => <li key={b.number} className="md:grid md:grid-cols-2 md:items-center md:gap-10" data-id="element-125" data-mp="15t8l8vhy78cy">
            <img src={b.image} alt={`Bonus #${b.number}: ${b.title}`} className="block w-full md:rounded-3xl" loading="lazy" data-id="element-126" data-mp="1artcw6j4wjps" />
            <div className="px-5 pt-6 md:px-0 md:pt-0" data-id="element-127" data-mp="w24a66ve87ne">
              <div className="flex flex-wrap items-center gap-3" data-id="element-128" data-mp="w1cgj1lcwjzr">
                <span className="rounded-lg bg-navy px-3 py-1 text-sm font-extrabold uppercase tracking-wider text-white" data-id="element-129" data-mp="10vgkrd38mdx5">
                  Bonus #{b.number}
                </span>
                <span className="text-sm font-bold text-muted" data-id="element-130" data-mp="r5407kvfakr0">
                  Value: <span className="line-through decoration-alert decoration-2" data-id="element-131" data-mp="d3ro5kjdv3ae">${b.value}</span>{' '}
                  <span className="text-cta" data-id="element-132" data-mp="i3xi57d4l1vn">FREE today</span>
                </span>
              </div>
              <h3 className="mt-3 font-serif text-[28px] font-black leading-tight text-navy md:text-3xl" data-id="element-133" data-mp="2jt3c5ujtfxub">{b.title}</h3>
              {b.text.map(p => <p key={p} className="mt-3 text-[17px] leading-relaxed text-muted" data-id="element-134" data-mp="2ezqte11til9h">
                  {p}
                </p>)}
            </div>
          </li>)}
      </ol>

      <div className="mx-auto mt-14 max-w-5xl px-5" data-id="element-135" data-mp="25z2cmyl1i6sw">
        <CtaButton label="I want all 5 bonuses free" data-id="element-136" data-mp="32rpj3q20kj65" />
      </div>
    </section>;
}